import "core-js";
import jQuery from "jquery";
// import Swiper from "swiper";

const $ = jQuery;

$(document).ready(function () {
  // モバイルメニューの開閉
  $(".header-btn").click(function () {
    $(".header-btn, .header-sp,.fixed__banner").toggleClass("open");
  });

  // モバイルメニューのリンククリック時の処理
  $(".header-sp a").click(function () {
    $(".header-btn, .header-sp").removeClass("open");
  });

  // FAQボックスの開閉
  $(".front-faq-box").on("click", function () {
    $(this).toggleClass("open");
  });

  // ウィンドウ幅に応じた初期設定
  var isMobile = $(window).width() <= 768;

  $(".side-nav-box--title").each(function () {
    if (isMobile) {
      $(this).addClass("open");
      $(this).next(".side-nav-box--list").hide();
    } else {
      $(this).next(".side-nav-box--list").show();
    }
  });

  // サイドナビゲーションの開閉
  $(".side-nav-box--title").on("click", function () {
    $(this).toggleClass("open");
    $(this).next(".side-nav-box--list").stop(true, true).slideToggle();
  });

  // ウィンドウサイズ変更時の処理
  function checkWidth() {
    if ($(window).width() >= 768) {
      $(".faq-content .front-faq-box").addClass("open");
    }
  }
  checkWidth();
  $(window).resize(checkWidth);
});

// ページトップボタン
$(function () {
  const pageTop = $("#pagetop__link");
  pageTop.hide();
  $(window).scroll(function () {
    if ($(this).scrollTop() > 100) {
      pageTop.fadeIn(); // 100px以上スクロールしたらフェードイン
    } else {
      pageTop.fadeOut(); // 100px以下になったらフェードアウト
    }
  });
  pageTop.click(function () {
    $("body,html").animate(
      {
        scrollTop: 0,
      },
      0,
    );
    return false;
  });
});

(() => {
  const OPEN_DELAY_MS = 10; // 0.01秒

  // ポップアップを出さないパス（本体 + 配下も除外）
  const EXCLUDE_PATHS = ["/sale/", "/line/", "/document/"]; // 末尾スラッシュ前提

  let initialized = false;
  let timerId = null;

  const normalizePath = (p) => (p.endsWith("/") ? p : p + "/");

  const shouldExclude = (path) => {
    const currentPath = normalizePath(path || "/");
    return EXCLUDE_PATHS.some((base) => currentPath === base || currentPath.startsWith(base));
  };

  const init = () => {
    // bfcache/pageshow対策：同一ページで二重にタイマーが走らないようにガード
    if (initialized) return;
    initialized = true;

    const modal = document.getElementById("ac-exitModal");
    if (!modal) return;

    // 除外ページでは動かさない
    if (shouldExclude(window.location.pathname)) return;

    const open = () => {
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      document.documentElement.classList.add("is-ac-exit-open");
    };

    const close = () => {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      document.documentElement.classList.remove("is-ac-exit-open");
    };

    // 表示予約（※保存しないので、ページ遷移したら次ページでもまた予約される）
    timerId = window.setTimeout(open, OPEN_DELAY_MS);

    // 背景 or × クリックで閉じる（閉じたらこのページでは再表示しない）
    modal.addEventListener("click", (e) => {
      const closer = (e.target as Element).closest("[data-ac-exit-close]");
      if (!closer) return;
      e.preventDefault();
      if (timerId) window.clearTimeout(timerId);
      close();
    });
  };

  // 通常ロード
  document.addEventListener("DOMContentLoaded", init);

  // 戻る/進むで bfcache 復元されるSafari/iOS対策（DOMContentLoadedが走らない場合がある）
  window.addEventListener("pageshow", () => {
    // 復元時も初期化できるようにリセットしてから init
    initialized = false;
    init();
  });
})();
